export class BaseGroup {
    id: number;
    name: string;
    fiscalYearEnding: string;
    country: string;
    logo: string = null;
    logoContent: File;
    order: number;
    tenant: any;
    currentUserRole: any;
    tags: any[];
    firstTransactionDate: Date;

    public constructor(init?: Partial<BaseGroup>) {
        Object.assign(this, init);
    }

    getRoleName(): string {
        if (!this.currentUserRole) {
            return null;
        }
        return typeof this.currentUserRole === 'string' ? this.currentUserRole : this.currentUserRole.name;
    }
}
